function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}export var GplansAppComponent = {
  template: "\n    <div ui-view class=\"ui-main-wrap\"></div>\n  ",


  controller: /*#__PURE__*/function () {GplansAppComponentController.$inject = ["LayoutService"];
    function GplansAppComponentController(LayoutService) {
      "ngInject";_classCallCheck(this, GplansAppComponentController);
      this.layout = LayoutService;
      console.log(this);
    }_createClass(GplansAppComponentController, [{ key: "$onInit", value: function $onInit()

      {
        angular.element(document.documentElement).addClass('gplans-users-console');
      } }, { key: "$onDestroy", value: function $onDestroy()

      {
        angular.element(document.documentElement).removeClass('gplans-users-console');
      } }]);return GplansAppComponentController;}() };